module.exports = __webpack_public_path__ + "img/word-icon.159ea75.png";